import { Cart as CartT } from "store/apis/products";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import { ArrayElement } from "types/utils/ArrayElement";
import { getCartItemPeriodLabel } from "utils/getCartItemPeriodLabel";
import { ItemColumn } from "./CartTableColumn";

type CartItem = ArrayElement<CartT["cart_items"]>;

type MobileCartItemRowProps = {
  row: Row<CartItem>;
};

// Column ids generated by react-table from the accessors in CartTableColumn.
const CART_COLUMN_ID = {
  QUANTITY: "quantity",
  TOTAL: "total",
  ACTIONS: "actions",
} as const;

const renderCell = (cell?: Cell<CartItem, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileCartItemRow = ({ row }: MobileCartItemRowProps) => {
  const cellsById = Object.fromEntries(
    row.getAllCells().map((cell) => [cell.column.id, cell])
  );
  const periodLabel = getCartItemPeriodLabel(row.original);

  const quantity = (
    <span className="t-flex t-items-center t-gap-1">
      Qty: {renderCell(cellsById[CART_COLUMN_ID.QUANTITY])}
    </span>
  );

  return (
    <div className="t-flex t-flex-col t-gap-1">
      <div className="t-flex t-items-start t-justify-between t-gap-3">
        <div className="t-min-w-0 t-flex-1 t-text-subtext t-text-text-60">
          <ItemColumn
            cartItem={row.original}
            extraMetadata={[quantity, periodLabel]}
          />
        </div>
        <div className="t-flex t-shrink-0 t-items-center">
          {renderCell(cellsById[CART_COLUMN_ID.ACTIONS])}
        </div>
      </div>

      <div className="t-flex t-items-center t-gap-1 t-text-body t-text-text-60">
        Total: {renderCell(cellsById[CART_COLUMN_ID.TOTAL])}
      </div>
    </div>
  );
};
